import styled from 'styled-components';

export const FactSection = styled.section`
  padding: 15px 0 40px;
`;

export const Container = styled.section`
  padding: 35px 0 35px;
  text-align: center;
`;

export const Title = styled.h3``;

export const Description = styled.p``;
